import './App.scss';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Create a client instance for React Query
// This manages all the caching, background updates, and state
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long data stays fresh before refetching (5 minutes)
      staleTime: 5 * 60 * 1000,
      // How long data stays in cache when unused (10 minutes)
      gcTime: 10 * 60 * 1000,
      // Retry failed requests 3 times with exponential backoff
      retry: 3,
      // Don't refetch when window regains focus (we'll handle this manually)
      refetchOnWindowFocus: false,
    },
  },
});

export const App = () => {
  const location = useLocation();
  const hideHeaderPaths = ['/', '/login', '/stores', '/forgot-password', '/email-otp', '/reset-password', '/sign-up', '/privacy-policy'];
  const shouldShowHeader = !hideHeaderPaths.includes(location.pathname);

  return (
    // Provide React Query client to entire app
    <QueryClientProvider client={queryClient}>
      <div className="App">
        {shouldShowHeader && <Header />}
        <Outlet />
      </div>
    </QueryClientProvider>
  );
};
